import React from 'react'
import styled from 'styled-components'
import theme from "@shared/utils/theme";


const LogoutSuccessPageContainer = styled.div`
  color: ${ theme.palette.black };
  display: flex;
  flex-direction: column;
  
  .pageTitle{
    font-size: 24px;
    letter-spacing: 0.27px;
    margin-left: 20px;
    margin-top: 80px;
  }
  .pageTitle span {
    font-weight: bold;
  }
  
  .description {
    margin-left: 20px;
    margin-top: 60px;
    margin-right: 20px;
    word-break: break-word;
  }
  .nextTime{
    margin-top: 30px;
    font-size: 20px;
    font-weight: bold;
  }
`

import pimprenelle from '/images/pimprenelle.png'

function LogoutSuccessPage() {
  return <LogoutSuccessPageContainer>
    <div className="pageTitle">
      <img src={pimprenelle} alt="Pimprenelle" height="70px"/>
    </div>
    <div className="description">
      <div>Vous avez été déconnecté.e de l’application Pimprenelle avec succès.</div>
      <div className="nextTime">A bientôt.</div>
    </div>
  </LogoutSuccessPageContainer>
}

export default LogoutSuccessPage
